import { ILayerProps, IMainLayerScope, IPoint } from '@/version-types';

// 消除算法类型
export enum EliminateType {
    LEGACY = 'legacy', // 原手动消除，传统消除算法
    AI = 'ai', // AI 消除
}

// 画笔类型
export enum PenType {
    BRUSH = 'brush', // brush pen (涂抹笔)
    BOX = 'box', // rectangular box selection (矩形框选)
    LASSO = 'lasso', // lasso selection (套索圈选)
}

export type SelectionType = 'add' | 'remove';

export interface EliminateConfig {
    type: EliminateType;
    penSize: number;
    penType: PenType;
    manualApply: boolean; // 手动应用效果，非即涂即消
    canApply: boolean; // 可以开始消除
    selectionType: SelectionType; // 选区操作方式
    autoRecognizeWatermark: boolean; // 自动识别水印
    autoRecognizeText: boolean;
    autoRecognizeGlasses: boolean;
    autoRecognizePasserby: boolean;
    autoRecognizeLogo: boolean;
    watermarkMaskURL: string; // 水印遮罩图
    textMaskURL: string; // 文字遮罩图
    isWatermarkMaskUsed: boolean; // 水印遮罩图是否使用
    isTextMaskUsed: boolean; // 文字遮罩图是否使用
    isGlassesMaskUsed: boolean; // 眼镜遮罩图是否使用
    isPasserbyMaskUsed: boolean; // 路人遮罩图是否使用
    recognizeInfo?: unknown; // 识别信息
    autoGlare: boolean; //反光识别
}

export interface IPathInfo {
    d: string;
    stroke?: string;
    strokeWidth?: number;
    strokeDashArray?: number[];
    strokeDashOffset?: number;
    strokeLineCap?: 'butt' | 'round' | 'square';
    fill?: string;
}

export interface IDrawInfo {
    penType: PenType;
    points: IPoint[];
    penSize: number;
    selectionType: SelectionType;
}

export enum ELIMINATE_PEN_EVENT {
    DRAW_END = 'eliminate_pen_draw_end',
    APPLY_END = 'eliminate_pen_apply_end',
    LOADING = 'eliminate_pen_loading',
}

export type RecognizeTarget = 'text' | 'watermark' | 'text_watermark' | 'passerby' | 'glasses' | 'glare' | 'logo';
export interface EliminatePenOptions {
    isSelectionSaveToHistory?: boolean;
    // 手动消除是否要裁剪
    isManualCrop?: boolean;
    aiEliminateHandler?: (
        originalImageURL: string,
        maskURL: string,
        recognizeInfo: unknown,
        crop?: boolean,
    ) => Promise<{ url: string }>;
    recognizeHandler?: (
        originalImageURL: string,
        target: RecognizeTarget,
    ) => Promise<{ url: string; recognizeInfo: unknown }>;
    recognizeAndEliminateHandler?: (originalImageURL: string, target: RecognizeTarget) => Promise<{ url: string }>;
}

// /**
//  * 需要依赖的编辑器上下文
//  */
// export interface IEliminatePenPluginContext {
//     drawLayers: (layers: ILayerProps[], extension?: string, noBg?: boolean) => Promise<HTMLCanvasElement>;
//     replaceLayer: (
//         ids: string | string[],
//         newLayers: ILayerProps | ILayerProps[],
//         historyFlag?: unknown,
//         trackFunc?: string,
//     ) => string[];
//     getScope: () => IMainLayerScope;
// }
